"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 71.45 24",
    width: "71.45",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m70.67 0h-67.34a.78.78 0 0 0 -.78.78v1.07h-1.84a.71.71 0 0 0 -.71.71v12a.71.71 0 0 0 .71.71h1.84v1.18a.78.78 0 0 0 .56.75l3.41 1v5a.78.78 0 1 0 1.56 0v-4.57l3.59 1a.83.83 0 0 0 .22 0h25.11a.78.78 0 1 0 0-1.56h-25l-7.9-2.21v-14.29h65.79v16.57h-5.29a.78.78 0 1 0 0 1.56h6.07a.78.78 0 0 0 .78-.78v-18.13a.78.78 0 0 0 -.78-.79z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m50.74 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m59.52 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m42 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.31 2.36z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m45.26 3.34h10.96v10.96h-10.96z"
  }));
};

exports["default"] = _default;